var _excluded = ["onChange"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import Select from '../Select.react';
var SelectInternalUrl = function SelectInternalUrl(_ref) {
  var _onChange = _ref.onChange,
    rest = _objectWithoutProperties(_ref, _excluded);
  var departmentsArr = [{
    sLabel: 'Civil',
    sValue: 'civil',
    sLogo: '5fad750e3b2d9030f0ef05e8'
  }
  // {
  // 	sLabel: 'Materials',
  // 	sValue: 'materials',
  // 	sLogo: '5f2432ae8ff2ea1c0844afc8',
  // },
  // {
  // 	sLabel: 'Environmental',
  // 	sValue: 'environmental',
  // 	sLogo: '5f1883115c4cec0e78f9fdb4',
  // },
  // {
  // 	sLabel: 'Paving',
  // 	sValue: 'paving',
  // 	sLogo: '5f162929b50a5d2514cecfdd',
  // },
  // {
  // 	sLabel: 'Drilling',
  // 	sValue: 'drilling',
  // 	sLogo: '5f1883395c4cec0e78f9fdb5',
  // },
  // {
  // 	sLabel: 'Utilities',
  // 	sValue: 'utilities',
  // 	sLogo: '5f1883495c4cec0e78f9fdb6',
  // },
  // {
  // 	sLabel: 'Development',
  // 	sValue: 'development',
  // 	sLogo: '5f1883585c4cec0e78f9fdb7',
  // },
  ];
  return /*#__PURE__*/React.createElement(Select, _extends({
    options: departmentsArr.sort(function (a, b) {
      return a.sLabel.localeCompare(b.sLabel);
    }).map(function (x) {
      return x;
    })
  }, rest, {
    onChange: function onChange(option) {
      _onChange(option);
    }
  }));
};
export default SelectInternalUrl;